import React from 'react';
import './short-tours.css';
import { Link } from "react-router-dom";




function ShortLongTerm() {
  return (
    <section className="short-long-term" aria-labelledby="short-long-term-heading">
      <div className="term-container">
        {/* Hero Section */}
        <div className="term-hero">
          <div className="term-hero-content">
            <h1 id="short-long-term-heading" className="term-hero-title">
              Short & Long Term Vehicle Rentals
            </h1>
            <p className="term-hero-description">
              Flexible rental solutions for every need. From hourly rentals to monthly contracts, 
              we provide reliable vehicles with professional service for all your transportation requirements.
            </p>
            <div className="term-hero-buttons">
              
                 <Link to="/bookings">
              <button className="term-cta-button primary">Book Short Term</button></Link>
             
            </div>
            <div className="term-stats">
              <div className="term-stat-item">
                <div className="term-stat-number">24/7</div>
                <div className="term-stat-label">Service Available</div>
              </div>
              <div className="term-stat-item">
                <div className="term-stat-number">100+</div>
                <div className="term-stat-label">Vehicles</div>
              </div>
              <div className="term-stat-item">
                <div className="term-stat-number">500+</div>
                <div className="term-stat-label">Happy Clients</div>
              </div>
            </div>
          </div>
          <div className="term-hero-image">
            <img 
              src="/shortlongrent.png" 
              alt="Fleet of rental vehicles available for short and long term rentals"
              loading="eager"
              width="600"
              height="400"
            />
          </div>
        </div>

        {/* Rental Types */}
        <div className="rental-types-section">
          <h2 className="term-section-title">Choose Your Rental Period</h2>
          <div className="rental-types-grid">
            <div className="rental-type-card">
              <div className="rental-type-header">
                <h3>Hourly Rental</h3>
                <div className="rental-badge">Flexible</div>
              </div>
              <div className="rental-type-content">
                <div className="rental-price">
                  <span className="price">$15</span>
                  <span className="period">per hour</span>
                </div>
                <p>Perfect for quick trips, meetings, and short errands</p>
                <ul className="rental-features">
                  <li>✓ Minimum 2 hours</li>
                  <li>✓ Within city limits</li>
                  <li>✓ Fuel included</li>
                  <li>✓ Insurance covered</li>
                </ul>
                <div className="suitable-for">
                  <h4>Ideal For:</h4>
                  <div className="suitable-tags">
                    <span>Business Meetings</span>
                    <span>Airport Drop</span>
                    <span>City Tours</span>
                  </div>
                </div>
                       <Link to="/bookings">
                <button className="rental-book-btn">Book Hourly</button></Link>
              </div>
            </div>

            <div className="rental-type-card featured">
              <div className="popular-badge">Most Popular</div>
              <div className="rental-type-header">
                <h3>Daily Rental</h3>
                <div className="rental-badge">Best Value</div>
              </div>
              <div className="rental-type-content">
                <div className="rental-price">
                  <span className="price">$99</span>
                  <span className="period">per day</span>
                </div>
                <p>Full day service for comprehensive travel needs</p>
                <ul className="rental-features">
                  <li>✓ 8 hours / 80 km included</li>
                  <li>✓ Extra km: $1.5</li>
                  <li>✓ Driver included</li>
                  <li>✓ Full insurance</li>
                  <li>✓ 24/7 support</li>
                </ul>
                <div className="suitable-for">
                  <h4>Ideal For:</h4>
                  <div className="suitable-tags">
                    <span>Business Travel</span>
                    <span>Family Outings</span>
                    <span>Event Transportation</span>
                  </div>
                </div>
                       <Link to="/bookings">
                <button className="rental-book-btn">Book Daily</button></Link>
              </div>
            </div>

            <div className="rental-type-card">
              <div className="rental-type-header">
                <h3>Weekly Rental</h3>
                <div className="rental-badge">Economical</div>
              </div>
              <div className="rental-type-content">
                <div className="rental-price">
                  <span className="price">$599</span>
                  <span className="period">per week</span>
                </div>
                <p>Extended rental with significant savings</p>
                <ul className="rental-features">
                  <li>✓ 7 days / 500 km included</li>
                  <li>✓ Extra km: $1.2</li>
                  <li>✓ Dedicated driver</li>
                  <li>✓ Comprehensive insurance</li>
                  <li>✓ Free maintenance</li>
                </ul>
                <div className="suitable-for">
                  <h4>Ideal For:</h4>
                  <div className="suitable-tags">
                    <span>Project Work</span>
                    <span>Vacation Travel</span>
                    <span>Corporate Events</span>
                  </div>
                </div>
                       <Link to="/bookings">
                <button className="rental-book-btn">Book Weekly</button></Link>
              </div>
            </div>
          </div>
        </div>

        {/* Long Term Rental Section */}
        <div className="long-term-section">
          <div className="long-term-content">
            <div className="long-term-info">
              <h2 className="term-section-title">Long Term Rental Solutions</h2>
              <p className="long-term-description">
                Perfect for businesses, projects, and extended stays. Our long-term rental packages 
                offer maximum value with dedicated vehicles and personalized service.
              </p>
              <div className="long-term-features">
                <div className="long-term-feature">
                  <div className="feature-icon">1</div>
                  <div className="feature-text">
                    <h4>Monthly Contracts</h4>
                    <p>Flexible monthly agreements with discounted rates</p>
                  </div>
                </div>
                <div className="long-term-feature">
                  <div className="feature-icon">2</div>
                  <div className="feature-text">
                    <h4>Dedicated Vehicles</h4>
                    <p>Same vehicle and driver for consistency</p>
                  </div>
                </div>
                <div className="long-term-feature">
                  <div className="feature-icon">3</div>
                  <div className="feature-text">
                    <h4>Maintenance Included</h4>
                    <p>Regular servicing and maintenance covered</p>
                  </div>
                </div>
                <div className="long-term-feature">
                  <div className="feature-icon">4</div>
                  <div className="feature-text">
                    <h4>Account Manager</h4>
                    <p>Dedicated contact for all your needs</p>
                  </div>
                </div>
              </div>
              <div className="long-term-pricing">
                <div className="pricing-option">
                  <span className="duration">1 Month</span>
                  <span className="price">$1,999</span>
                  <span className="savings">Save 15%</span>
                </div>
                <div className="pricing-option featured">
                  <span className="duration">3 Months</span>
                  <span className="price">$5,399</span>
                  <span className="savings">Save 25%</span>
                </div>
                <div className="pricing-option">
                  <span className="duration">6 Months</span>
                  <span className="price">$9,999</span>
                  <span className="savings">Save 30%</span>
                </div>
                <div className="pricing-option">
                  <span className="duration">12 Months</span>
                  <span className="price">$18,999</span>
                  <span className="savings">Save 35%</span>
                </div>
              </div>


          <a
  href="https://wa.me/94701707707?text=Hello!%20I%20would%20like%20to%20request%20a%20custom%20quote."
  target="_blank"
  rel="noopener noreferrer"
  className="watsapp-link"
>
  <button className="long-term-inquiry-btn">Request Custom Quote</button>
</a>



            </div>
            <div className="long-term-image">
              <img 
                src="/van.png" 
                alt="Professional long term rental vehicle for corporate and business use"
                loading="lazy"
                width="500"
                height="400"
              />
            </div>
          </div>
        </div>

        {/* Vehicle Categories */}
        <div className="vehicle-categories-section">
          <h2 className="term-section-title">Vehicle Categories</h2>
          <div className="vehicle-categories-grid">
            <div className="vehicle-category-card">
              <div className="category-icon"></div>
              <h3>Economy Sedans</h3>
              <p>Fuel-efficient cars for budget-conscious travelers</p>
              <div className="category-vehicles">
                <span>Toyota Corolla</span>
                <span>Honda Civic</span>
                <span>Hyundai Elantra</span>
              </div>
              <div className="category-pricing">
                <span>From $12/hour</span>
                <span>From $79/day</span>
              </div>
            </div>
            <div className="vehicle-category-card">
              <div className="category-icon"></div>
              <h3>Premium Sedans</h3>
              <p>Luxury vehicles for business and special occasions</p>
              <div className="category-vehicles">
                <span>Mercedes E-Class</span>
                <span>BMW 5 Series</span>
                <span>Audi A6</span>
              </div>
              <div className="category-pricing">
                <span>From $25/hour</span>
                <span>From $149/day</span>
              </div>
            </div>
            <div className="vehicle-category-card">
              <div className="category-icon"></div>
              <h3>SUVs & Vans</h3>
              <p>Spacious vehicles for groups and family travel</p>
              <div className="category-vehicles">
                <span>Toyota Fortuner</span>
                <span>Honda CR-V</span>
                <span>Premium Minivan</span>
              </div>
              <div className="category-pricing">
                <span>From $20/hour</span>
                <span>From $129/day</span>
              </div>
            </div>
            <div className="vehicle-category-card">
              <div className="category-icon"></div>
              <h3>Luxury Vehicles</h3>
              <p>Premium cars for VIP transportation and events</p>
              <div className="category-vehicles">
                <span>Mercedes S-Class</span>
                <span>BMW 7 Series</span>
                <span>Range Rover</span>
              </div>
              <div className="category-pricing">
                <span>From $50/hour</span>
                <span>From $299/day</span>
              </div>
            </div>
          </div>
        </div>

        {/* Rental Process */}
        <div className="rental-process-section">
          <h2 className="term-section-title">Simple Rental Process</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-icon"></div>
              <div className="step-content">
                <h3>Book Online</h3>
                <p>Select your vehicle, dates, and rental period</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-icon"></div>
              <div className="step-content">
                <h3>Get Confirmation</h3>
                <p>Instant confirmation with all details</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-icon"></div>
              <div className="step-content">
                <h3>Vehicle Delivery</h3>
                <p>Vehicle delivered to your location</p>
              </div>
            </div>
            <div className="process-step">
              <div className="step-icon"></div>
              <div className="step-content">
                <h3>Enjoy Your Ride</h3>
                <p>Professional service throughout your rental</p>
              </div>
            </div>
          </div>
        </div>

       

        {/* CTA Section */}
        <div className="term-cta-section">
          <div className="term-cta-content">
            <h2>Ready to Book Your Rental?</h2>
            <p>Choose from our flexible rental options and enjoy reliable transportation</p>
            <div className="term-cta-buttons">
              
                 <Link to="/bookings">
              <button className="term-cta-button large primary">Book Now</button></Link>

              <a href="tel:+94701707707" className="term-cta-link">
  <button className="term-cta-button large outline">
    Call: +94 70 170 7707
  </button>
</a>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ShortLongTerm;